import { defineStore } from 'pinia'

export const useMasterSlidesStore = defineStore('masterSlides', {
  state: () => ({
    masterSlides: [{
      masterSlideId: '',
      slide: null
    }]
  }),

  getters: {}
})
